export const validateAudienceConditions = (metadata_info) => {
  let isConditionsValidated = [false];

  if (metadata_info.serviceName != "IfElseService") {
    isConditionsValidated.pop();
    isConditionsValidated.push(true);
  }

  if (
    metadata_info &&
    metadata_info.length > 0
  ) {
    isConditionsValidated.pop();
    metadata_info.some((obj, idx) => {
      let arr = [
        "filterActionId",
        "filterValue",
        "filterPropertyId",
        "logicalOperator",
        "filterValueTypeId",
        "filterParameters",
      ];
      arr.some((properties, ids) => {
        if (properties === "filterParameters") {
          console.log(properties)
          if (obj[properties] !== undefined || obj[properties] !== null) {
            obj[properties].map((param, idxs) => {
              if (
                param.value === undefined ||
                param.value === null ||
                param.value === "" ||
                param.filterPropertyParameterId === undefined ||
                param.filterPropertyParameterId === null
              ) {


                isConditionsValidated.push(false);
              }
            });
          }
        } else if (
          obj[properties] === null ||
          obj[properties] === undefined ||
          obj[properties] === ""
        ) {
          isConditionsValidated.push(false);
        } else {
          isConditionsValidated.push(true);
        }
      });
    });

    return isConditionsValidated.includes(false) ? false : true;
  }

  return isConditionsValidated.includes(false) ? false : true;
};